export default __webpack_public_path__ + "static/media/Japan_Particle_0003_Yamato_Blast2.1cf54ae9.png";